import React from 'react'
import * as THREE from 'three'

// Copyright (c) 2022 by Victor Vergara (https://codepen.io/vcomics/pen/djqNrm)

// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

export function PerlinWaves() {
  // Three JS
  const Theme = { _darkred: 0x000000 }

  React.useEffect(() => {
    // window.addEventListener('load', init, false)
    createWorld()
    createPrimitive()
    // createGUI()
    //---
    animation()
  }, [])

  //--------------------------------------------------------------------

  var scene, camera, renderer, container
  var start = Date.now()
  var _width, _height
  const createWorld = () => {
    _width = 400
    _height = 400
    //---
    scene = new THREE.Scene()
    //scene.fog = new THREE.Fog(Theme._darkred, 8, 20);
    scene.background = new THREE.Color(Theme._darkred)
    //---
    camera = new THREE.PerspectiveCamera(55, _width / _height, 1, 1000)
    camera.position.z = 12 //12
    //---
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false })
    renderer.setSize(_width, _height)
    //---
    container = document.getElementById('canvas-container')
    container.appendChild(renderer.domElement)
    //---
    // window.addEventListener('resize', onWindowResize, false)
  }

  // function onWindowResize() {
  //   _width = window.innerWidth
  //   _height = window.innerHeight
  //   renderer.setSize(_width, _height)
  //   camera.aspect = _width / _height
  //   camera.updateProjectionMatrix()
  // }

  //--------------------------------------------------------------------

  var mat
  var primitiveElement = function () {
    this.mesh = new THREE.Object3D()
    mat = new THREE.ShaderMaterial({
      wireframe: false,
      //fog: true,
      uniforms: {
        time: {
          type: 'f',
          value: 0.0,
        },
        pointscale: {
          type: 'f',
          value: 0.0,
        },
        decay: {
          type: 'f',
          value: 0.0,
        },
        complex: {
          type: 'f',
          value: 0.0,
        },
        waves: {
          type: 'f',
          value: 0.0,
        },
        eqcolor: {
          type: 'f',
          value: 0.0,
        },
        fragment: {
          type: 'i',
          value: true,
        },
        redhell: {
          type: 'i',
          value: true,
        },
      },
      vertexShader: document.getElementById('vertexShader').textContent,
      fragmentShader: document.getElementById('fragmentShader').textContent,
    })
    var geo = new THREE.IcosahedronBufferGeometry(3, 40) // 3, 7
    var mesh = new THREE.Points(geo, mat)

    //---
    this.mesh.add(mesh)
  }

  var _primitive
  function createPrimitive() {
    _primitive = new primitiveElement()
    scene.add(_primitive.mesh)
  }

  //--------------------------------------------------------------------

  var options = {
    perlin: {
      vel: 0.002,
      speed: 0.0001,
      perlins: 1.25, // size
      decay: 0.2,
      complex: 0.3,
      waves: 9.0,
      eqcolor: 10.0, // hue
      fragment: true,
      redhell: true,
    },
    spin: {
      sinVel: 0.0,
      ampVel: 80.0,
    },
  }

  //--------------------------------------------------------------------

  function animation() {
    requestAnimationFrame(animation)
    var performance = Date.now() * 0.003

    _primitive.mesh.rotation.y += options.perlin.vel
    _primitive.mesh.rotation.x =
      (Math.sin(performance * options.spin.sinVel) *
        options.spin.ampVel *
        Math.PI) /
      180
    //---
    mat.uniforms['time'].value = options.perlin.speed * (Date.now() - start)
    mat.uniforms['pointscale'].value = options.perlin.perlins
    mat.uniforms['decay'].value = options.perlin.decay
    mat.uniforms['complex'].value = options.perlin.complex
    mat.uniforms['waves'].value = options.perlin.waves
    mat.uniforms['eqcolor'].value = options.perlin.eqcolor
    mat.uniforms['fragment'].value = options.perlin.fragment
    mat.uniforms['redhell'].value = options.perlin.redhell
    //---
    camera.lookAt(scene.position)
    renderer.render(scene, camera)
  }

  return <div id="canvas-container" />
}
